/**
 * ExitIcon/index.js
 * desc: system icon for exit step type (includes EXIT and REVIEW_EXIT)
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ExitIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="exit icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.exit.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 11"><path d="M16.59 0L9 7.59 3.41 2H8V0H0v8h2V3.41l7 7 9-9L16.59 0z"/></svg>
    </IconButton>
);


export default ExitIcon;
